import React from 'react'
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import styles from './Icon.scss';
import SVG from 'react-inlinesvg';



import hamburger from './assets/hamburger.svg'
import settingsmenu from './assets/settingsmenu.svg'
import success from './assets/input-success.svg'
import warning from './assets/input-warning.svg'
import error from './assets/input-error.svg'
import hint from './assets/input-hint.svg'
import yes from './assets/yes.svg'
import no from './assets/no.svg'
import cost from './assets/cost.svg'
import time from './assets/time.svg'
import settings from './assets/content-settings.svg'
import menusettings from './assets/menu-settings.svg'
import profile from './assets/profile.svg'
import password from './assets/password.svg'
import company from './assets/company.svg'
import cedit from './assets/content-edit.svg'
import cexport from './assets/content-export.svg'
import cdelete from './assets/content-delete.svg'
import search from './assets/input-search.svg'
import calendar from './assets/input-calendar.svg'
import close from './assets/close.svg'
import logout from './assets/logout.svg'
import questionmark from './assets/questionmark.svg'
import hintbulb from './assets/hint.svg'
import average from './assets/average.svg'
import account from './assets/account.svg'
import info from './assets/info.svg'


const Icon = (props) => {
	if(props.type=='image'){
		var icon = '';
		switch(props.content) {
			case 'hamburger':
				icon = hamburger;
			break;
			case 'settingsmenu':
				icon = settingsmenu;
			break;
			case 'success':
				icon = success;
			break;
			case 'warning':
				icon = warning;
			break;
			case 'error':
				icon = error;
			break;
			case 'hint':
				icon = hint;
			break;
			case 'yes':
				icon = yes;
			break;
			case 'no':
				icon = no;
			break;
			case 'cost':
				icon = cost;
			break;
			case 'time':
				icon = time;
			break;
			case 'settings':
				icon = settings;
			break;
			case 'menusettings':
				icon = menusettings;
			break;
			case 'profile':
				icon = profile;
			break;
			case 'password':
				icon = password;
			break;
			case 'company':
				icon = company;
			break;
			case 'edit':
				icon = cedit;
			break;
			case 'export':
				icon = cexport;
			break;
			case 'delete':
				icon = cdelete;
			break;
			case 'search':
				icon = search;
			break;
			case 'calendar':
				icon = calendar;
			break;
			case 'close':
				icon = close;
			break;
			case 'logout':
				icon = logout;
			break;
			case 'questionmark':
				icon = questionmark;
			break;
			case 'hintbulb':
				icon = hintbulb;
			break;
			case 'average':
				icon = average;
			break;
			case 'account':
				icon = account;
			break;
			case 'info':
				icon = info;
			break;
			default:
				icon = hamburger;
		}

		let classNames = styles.icon

		if(props.display=='inline'){
			classNames = classNames + ' ' + styles.isInline
		}
		if(props.isHiddenDesktop){
			classNames = classNames + ' ' + styles.isHiddenDesktop
		}
		if(props.isHiddenMobile){
			classNames = classNames + ' ' + styles.isHiddenMobile
		}

		let styleAdd = {
                  width: '25px',
                  height: '25px'
              };

		if(props.size){
			styleAdd = {
                  width: props.size,
                  height: props.size
              }
		}
  		return (
  			<span title={props.translate('global.icons.'+props.content)}>
  			<SVG
			    src={icon}
			    className={classNames}        
			  	style={styleAdd}>
			>
			</SVG>
			</span>
  		)
	}else if(props.type=='text'){
		return (
			<div className={styles.iconText} >{props.text}</div>
		)
	}
}


const mapStateToProps = state => {
    return {
        translate: getTranslate(state.locale)
    };
};
export default connect(mapStateToProps)(Icon);



// WEBPACK FOOTER //
// ./src/components/atoms/Icon/index.js